/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var SimpleRevisionTypeEnums;

(function (SimpleRevisionTypeEnums) {
  SimpleRevisionTypeEnums["DOC_FILE"] = "doc_file";
  SimpleRevisionTypeEnums["FILE_URL"] = "file_url";
})(SimpleRevisionTypeEnums || (SimpleRevisionTypeEnums = {}));